<template>
  <zj-layout-container>
    <zj-layout-header>
      <div class="listtitle">经营数据上报</div>
    </zj-layout-header>
    <zj-layout-main>
      <div class="zj-layout-main-content bgcolor scrollable" style="overflow: auto">
        <el-form
          ref="form"
          :model="data"
          :rules="rules"
          label-width="16rem"
          style="width: 80%"
          v-loading="loading"
          :element-loading-text="loadingText"
          :disabled="IsEdit"
        >
          <el-row>
            <el-col :span="12">
              <el-form-item label="上报点位" prop="ReportStationId">
                <el-select v-model="data.ReportStationId" placeholder="请选择" style="width:100%">
                  <el-option
                    v-for="item in ReportStationArr"
                    :key="item.ItemKey"
                    :label="item.Description"
                    :value="item.ItemKey"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="上报日期" prop="ReportDate">
                <el-date-picker
                  v-model="ReportDate"
                  type="date"
                  style="width:100%"
                  :clearable="false"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="上报时间段" prop="ReportDate">
                <el-time-picker
                  is-range
                  v-model="DateTimeSpan"
                  range-separator="至"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  placeholder="选择时间范围"
                  :clearable="false"
                  style="width:100%"
                  size="50"
                ></el-time-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="上报人次" prop="ReportNumber">
                <el-input-number
                  v-model="data.ReportNumber"
                  style="width:100%"
                  controls-position="right"
                  :min="0"
                ></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="上报收入" prop="ReportMoney">
                <el-input-number
                  v-model="data.ReportMoney"
                  style="width:100%"
                  controls-position="right"
                  :min="0"
                ></el-input-number>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="上报人" prop="Creater">
                <el-input v-model="data.Creater" disabled="true"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="上报方式" prop="ReportSource">
                <el-input v-model="data.ReportSource" disabled="true"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </zj-layout-main>
    <zj-layout-footer>
      <el-form>
        <el-form-item class="right">
          <el-button @click="onBack()">返回</el-button>
          <el-button type="primary" @click="saveForm()" v-if="!IsEdit">保存</el-button>
        </el-form-item>
      </el-form>
    </zj-layout-footer>
  </zj-layout-container>
</template>
<script>
import MyApis from "../../../apis";
import ZJApp from "../../../../../app";

export default {
  name: "TourReportManagerInfo",
  controller: "UI",
  action: "TourReportManagerInfo",
  data() {
    return {
      data: {
        Creater: ZJApp.ZJUser.current.UserName,
        ReportSource: "管理平台",
        ReportStationId: "",
        ReportNumber: 0,
        ReportMoney: 0,
      },
      ReportDate: new Date(),
      DateTimeSpan: [new Date(2020, 9, 10, 0, 0), new Date(2020, 9, 10, 23, 59)],
      loading: false,
      loadingText: "加载中...",
      IsEdit: false,
      rules: {
        ReportStationId: [
          { required: true, message: "请选择上报点位", trigger: "blur" },
        ],
      },
      ReportStationId: "",
      ReportStationArr: [],
    };
  },
  created: function () {
    if (this.$route.query.InfoId) {
      this.search();
    }
    if (this.$route.query.type == "query") {
      this.IsEdit = true;
    } else {
      this.IsEdit = false;
    }
    this.getStation();
  },
  methods: {
    // 弹出一个错误消息
    errmsg(msg) {
      this.$message({
        showClose: true,
        message: msg || "",
        type: "error",
        customClass: "zj-login-msgbox",
      });
    },
    getStation() {
      this.config
        .getUValue("System.Report:System.Report.Station", "")
        .then((d) => {
          this.ReportStationArr = d.JValue;
        })
        .catch((e) => console.error(e));
    },
    search() {
      let InfoId = this.$route.query.InfoId;
      if (InfoId) {
        this.loading = true;
        new MyApis.TourReportResourcesApi()
          .GetItemById({ ID: InfoId })
          .then((r) => {
            r = r.data.Data;
            console.log(r);
            this.data = r;
            this.ReportDate = this.data.ReportStartTime;
            this.DateTimeSpan = [
              this.data.ReportStartTime,
              this.data.ReportEndTime,
            ];
            this.loading = false;
          })
          .catch((e) => {
            this.loading = false;
            console.log(e);
            this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          });
      }
    },
    //返回按钮
    onBack() {
      this.$router.go(-1); //返回上一层
    },
    //保存
    saveForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.saveData();
        } else {
          return false;
        }
      });
    },
    saveData() {
      this.data.ReportStartTime = new Date(
        this.ReportDate.format("yyyy-MM-dd") +
          " " +
          this.DateTimeSpan[0].format("hh:mm:ss")
      );
      this.data.ReportEndTime = new Date(
        this.ReportDate.format("yyyy-MM-dd") +
          " " +
          this.DateTimeSpan[1].format("hh:mm:ss")
      );
      var stationid = this.data.ReportStationId;

      this.ReportStationArr.forEach((item) => {
        if (item.ItemKey == stationid) {
          this.data.ReportStationName = item.Description;
        }
      });
      this.data.Validity = 1;
      if (this.$route.query.type == "add") {
        this.data.ID = ZJApp.ZJUtils.uuid();
      }

      this.loading = true;
      this.loadingText = "保存中...";
      if (this.$route.query.type == "edit") {
        //编辑
        this.data.ModifyTime = new Date();
        this.data.Modifier = ZJApp.ZJUser.current.UserName;

        new MyApis.TourReportResourcesApi()
          .UpdateItem(this.data)
          .then((r) => {
            r = r.data.Data;
            this.$message({
              type: "success",
              message: r ? "保存成功！" : "保存失败！",
            });
            this.loading = false;
            this.$router.go(-1); //返回上一层
          })
          .catch((e) => {
            this.loading = false;
            console.log(e);
            this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          });
      } else {
        this.data.CreateTime = new Date();
        this.data.Creater = ZJApp.ZJUser.current.UserName;
        this.data.ReportTime = new Date();
        console.log(this.data);
        new MyApis.TourReportResourcesApi()
          .AddItem(this.data)
          .then((r) => {
            r = r.data.Data;
            this.$message({
              type: "success",
              message: r ? "保存成功！" : "保存失败！",
            });
            this.loading = false;
            this.$router.go(-1); //返回上一层
          })
          .catch((e) => {
            this.loading = false;
            console.log(e);
            this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          });
      }
    },
  },
};
</script>
